import React from 'react'
import Section from '../../../../components/section'
import Text from '../../../../components/text'
import Input from '../../../../components/input'
import Button from '../../../../components/button'
import useLogin from '../../login/hooks/login.hook'
import {useFormik} from "formik";
import * as Yup from "yup";
import Flex from '../../../../components/flex'
import useHttpHandler from "../../../../hooks/httpHandler";
import {toast} from "react-toastify";

const ForgotPasswordView = () => {
    const {
        goBackToLogin
    } = useLogin();

    const {post} = useHttpHandler()

    const onSubmitResetPassword=(values, actions)=>{
        post('auth/reset-password', values).then((res)=>{
            actions.setSubmitting(false)
            toast.success('Reset Password Email Sent')
        }).catch(err => {
            actions.setSubmitting(false)
        })

    }

    const formik = useFormik({
        initialValues: {
            uname: '',
        },
        validationSchema: Yup.object({
            uname: Yup.string().required('Please enter a valid email address').email('Please enter a valid email address'),
        }),
        onSubmit: (values, actions) => {
            const body = {
                email: values.uname
            }
            onSubmitResetPassword(body, actions)
        }
    });
    return (
        <>
            <Section>
                <div className="row">
                    <div className="col-12 col-md-5 mx-auto">
                    <div className="auth-form-wrapper">
                        <Text type="H1" text="Forgot Password" className="page-title mb-4" />
                        <form onSubmit={formik.handleSubmit}>
                            <div className="formBox">
                                <Input
                                    label="Email Address"
                                    type="text"
                                    name="uname"
                                    placeholder="Your Email Address"
                                    autoFocus={true}
                                    value={formik.values.uname}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    mandatory
                                    errormessage={formik.touched.uname && formik.errors.uname ? (
                                        formik.errors.uname
                                    ) : null}
                                />
                            </div>
                            <Flex justifyContent="end" className="mb-48">
                                <Button
                                    link
                                    text="Back to login"
                                    onClick={goBackToLogin}
                                    type="button"
                                />
                            </Flex>
                            <Flex justifyContent="center" className="mb-48">
                                <Button
                                    type="submit"
                                    text="Send email"
                                    large
                                    isSubmitting={formik.isSubmitting}
                                    disabled={formik.isSubmitting}
                                />
                            </Flex>
                        </form>
                        </div>
                    </div>
                </div>
            </Section>
        </>
    )
}

export default ForgotPasswordView